<template>
  <div class="system_introduced">
    <img src="../../assets/imgs/system_introduced/header.png" alt />
    <img src="../../assets/imgs/system_introduced/1.png" alt />
    <img src="../../assets/imgs/system_introduced/2.png" alt />
    <img src="../../assets/imgs/system_introduced/3.png" alt />
    <img src="../../assets/imgs/system_introduced/4.png" alt />
    <img src="../../assets/imgs/system_introduced/5.png" alt />
    <img src="../../assets/imgs/system_introduced/6.png" alt />
    <div class="img-show8">
      <div class="title">
        综合金融服务
        <span>体系</span>
      </div>
      <ul class="listItem">
        <li v-for="(item,index) in list" :key="index" @click="download(item.img)">
          <a :href="baseUrl + item.img" target="_blank">{{item.name}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as indexApi from "@/api/index";
import baseUrl from "@/api/baseUrl";

export default {
  data() {
    return {
      list: []
    };
  },
  created() {
    this.getPdf();
  },
  methods: {
    // 获取pdf文件
    getPdf() {
      indexApi.getFilePdf().then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    download(img) {
      console.log(img);
      window.open(baseUrl + img);
    }
  }
};
</script>

<style lang="less" scoped>
.system_introduced {
  // width: 100%;
  // height: 1080px;
  overflow: auto;
  background-color: white;
  img {
    width: 100%;
    height: auto;
  }
  .img-show8 {
    min-height: 601px;
    width: 100%;
    background: #215c9e;
    padding-top: 65px;
    padding-bottom: 50px;
    .title {
      font-family: "MicrosoftYaHei";
      font-size: 45px;
      color: #ffffff;
      line-height: 60px;
      text-align: center;
      position: relative;
      span {
        color: #e1750b;
      }
    }
    .title::before {
      content: "";
      display: block;
      position: absolute;
      top: 70px;
      left: 35%;
      width: 170px;
      height: 2px;
      opacity: 0.5;
      background: #7ecef4;
    }
    .title::after {
      content: "";
      display: block;
      position: absolute;
      top: 70px;
      right: 35%;
      width: 170px;
      height: 2px;
      opacity: 0.5;
      background: #7ecef4;
    }
    .listItem {
      width: 1280px;
      margin: 70px auto 0;
      overflow: hidden;
      li {
        box-sizing: border-box;
        width: 45%;
        height: 78px;
        background: #296ab3;
        border: 1px solid #3677bf;
        border-radius: 4px;
        float: left;
        margin: 0 5% 12px 0;
        cursor: pointer;
        padding: 17px 40px 17px 100px;
        position: relative;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #fff;
        list-style: none;
        a {
          color: #fff;
          text-decoration: none;
        }
      }
      li:nth-child(even) {
        margin-right: 0;
      }
      li::before {
        content: "";
        display: block;
        width: 36px;
        height: 43px;
        background: url(../../assets/imgs/system_introduced/pdf.png) no-repeat;
        background-size: 100% auto;
        position: absolute;
        top: 17px;
        left: 32px;
      }
    }
  }
}
</style>
